import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // [추가] react-router-dom에서 useLocation 임포트
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import './PolicyPage.css';

function PrivacyPolicyPage() {
    const [policyContent, setPolicyContent] = useState('');
    const { hash } = useLocation(); // [추가] 현재 URL의 hash 값을 가져옴

    // 기존 useEffect는 그대로 둡니다 (파일 로드용).
    useEffect(() => {
        fetch('/policies/privacy-policy.md')
            .then(response => response.text())
            .then(text => setPolicyContent(text));
    }, []);

    // [수정] 앵커 스크롤링을 위한 useEffect
    useEffect(() => {
        // URL에 hash가 있고, 마크다운 컨텐츠가 로드되었는지 확인
        if (hash && policyContent) {
            
            // setTimeout을 사용해 렌더링 후 스크롤이 될 시간을 보장합니다.
            setTimeout(() => {
                const id = decodeURIComponent(hash.replace('#', ''));
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100); // 100밀리초(0.1초) 후에 스크롤 실행

        }
    }, [hash, policyContent]); // hash 또는 policyContent가 변경될 때마다 실행

    return (
        <div className="policy-container">
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>{policyContent}</ReactMarkdown>
        </div>
    );
}

export default PrivacyPolicyPage;